
import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  DialogContent,
  Box,
  CircularProgress,
  Backdrop,
  Dialog,
  Grid,
 
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { changeVendorAccess } from "./actions";

export const VendorAccessPOPUP = ({
   open,
  close,
    setOpenModel , 
    changeVendorState , 
    formState , 
    selectedVendors , 
    setSelectedVendors , 
    setWaitMessage
    
}) =>{

    // const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false); 
     const handleClose = () => {
    // setOpen(false);
    setOpenModel(false);
   
    // clearState(setFormState,setUpdateId,setDeleteID, settogglebutton,setGetDataFromID);

    // setErrAlertMessage("")
  };

 const ChangeState = async () => {
    setLoading(true);
    setWaitMessage("Wait! your request is in progress...");

    try {
      await changeVendorAccess(
        selectedVendors,
        formState?.State,
        setOpenModel,
        setSelectedVendors,
        setWaitMessage
      );
    } finally {
      setLoading(false);
    }
  };

    return (

 <Dialog open={open} onClose={close} fullWidth={true}>
      <DialogContent>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        //   open={attachInvoiceLoading}
        open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
            <Grid  item xs={12} lg={6} sm={12} md={6} sx= {{  textAlign: "center", justifyContent:"center"}}>
          
            <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                        p={2}
                        mt={1}
                      >
                        <Typography variant="h4" style={{ width: "80%" }}>
                          Are you sure you want to  {formState?.State === "Unblocked" ? "Block" : "UnBlock"}  this vendor?
                        </Typography>
                      </Box>

                       <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                        m={1}
                      >
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={handleClose}
                        >
                          NO
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{ marginLeft: "20px" }}
                          onClick={ChangeState}
                          disabled={loading} 
                        >
                          Yes
                        </Button>
                      </Box>
            
                
            </Grid>



           
        </Box>
       
        
      </DialogContent>
    </Dialog>


    )
}